require('./displayMessage.styles');
const template = require('./displayMessage.template');

import { AuthService } from 'phoenix/services';
import { DisplayMessageService } from 'phoenix/services/displayMessageService';

export function DisplayMessageDirective(): ng.IDirective {
    return {
        restrict: 'E',
        controller: DisplayMessageController,
        controllerAs: 'vm',
        template,
        bindToController: true,
        scope: {
            header: '@',
            message: '@'
        }
    };
}

class DisplayMessageController {
    public static $inject = [
        'pxDisplayMessageService',
        'pxAuthService'
    ];

    public header: string;
    public message: string;

    constructor(
        private pxDisplayMessageService:DisplayMessageService, 
        private pxAuthService:AuthService) {
    }
}


// WEBPACK FOOTER //
// ./src/phoenix/components/displayMessage/displayMessage.component.ts